<template>
  <div id="app">
    <router-view/>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    if (!window.entryUrl) {
      window.entryUrl = location.href.split('#')[0]
    }
  },
  mounted () {
    window.addEventListener('orientationchange', e => {
      if (window.orientation === 90 || window.orientation == -90) {
        // TODO 进行横屏相关处理
      }
    })
    // 解决ios按钮active状态不会触发的问题
    this.$dom.on(document.body, 'touchstart', (e) => {})
    // window.addEventListener('')
  }
}
</script>

<style lang="scss">
#app {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue